import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ManagementPage = lazy(() => import('../pages/management/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const ForOwnersPage = lazy(() => import('../pages/for-owners/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const MinpakuRegistrationPage = lazy(() => import('../pages/minpaku-registration/page'));
const GuidePage = lazy(() => import('../pages/guide/page'));
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AirbnbTokyoGuidePage = lazy(() => import('../pages/airbnb-tokyo-guide/page'));
const CaseStudyPage = lazy(() => import('../pages/case-study/page'));
const AdsLandingPage = lazy(() => import('../pages/ads-landing/page'));
const AdminCalendarPage = lazy(() => import('../pages/admin-calendar/page'));
const ChildcarePage = lazy(() => import('../pages/childcare/page'));
const DrivingAssistantPage = lazy(() => import('../pages/driving-assistant/page'));
const DrivingAssistantEnPage = lazy(() => import('../pages/driving-assistant-en/page'));
const WechatZhPage = lazy(() => import('../pages/wechat-zh/page'));
const TokyoIzakayaNightPage = lazy(() => import('../pages/tokyo-izakaya-night/page'));
const TokyoIzakayaNightEnPage = lazy(() => import('../pages/tokyo-izakaya-night-en/page'));
const TokyoKaraokeNightPage = lazy(() => import('../pages/tokyo-karaoke-night/page'));
const TokyoKaraokeNightEnPage = lazy(() => import('../pages/tokyo-karaoke-night-en/page'));
const TokyoNightComboPage = lazy(() => import('../pages/tokyo-night-combo/page'));
const TokyoNightComboJaPage = lazy(() => import('../pages/tokyo-night-combo-ja/page'));
const OverseasOwnersPage = lazy(() => import('../pages/overseas-owners/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/management',
    element: <ManagementPage />,
  },
  {
    path: '/support',
    element: <Navigate to="/minpaku-license-support" replace />,
  },
  {
    path: '/minpaku-license-support',
    element: <SupportPage />,
  },
  {
    path: '/for-owners',
    element: <Navigate to="/tokyo-airbnb-support" replace />,
  },
  {
    path: '/tokyo-airbnb-support',
    element: <ForOwnersPage />,
  },
  {
    path: '/pricing',
    element: <Navigate to="/airbnb-management-tokyo" replace />,
  },
  {
    path: '/airbnb-management-tokyo',
    element: <PricingPage />,
  },
  {
    path: '/minpaku-registration-tokyo',
    element: <MinpakuRegistrationPage />,
  },
  {
    path: '/tokyo-minpaku-guide',
    element: <GuidePage />,
  },
  {
    path: '/airbnb-tokyo-legal-guide',
    element: <AirbnbTokyoGuidePage />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '/ota-city-case-study',
    element: <CaseStudyPage />,
  },
  {
    path: '/start-airbnb-tokyo',
    element: <AdsLandingPage />,
  },
  {
    path: '/admin/calendar',
    element: <AdminCalendarPage />,
  },
  {
    path: '/childcare',
    element: <ChildcarePage />,
  },
  {
    path: '/driving-assistant',
    element: <DrivingAssistantPage />,
  },
  {
    path: '/driving-assistant-en',
    element: <DrivingAssistantEnPage />,
  },
  {
    path: '/wechat-zh',
    element: <WechatZhPage />,
  },
  {
    path: '/tokyo-izakaya-night',
    element: <TokyoIzakayaNightPage />,
  },
  {
    path: '/tokyo-izakaya-night-en',
    element: <TokyoIzakayaNightEnPage />,
  },
  {
    path: '/tokyo-karaoke-night',
    element: <TokyoKaraokeNightPage />,
  },
  {
    path: '/tokyo-karaoke-night-en',
    element: <TokyoKaraokeNightEnPage />,
  },
  {
    path: '/tokyo-night-combo',
    element: <TokyoNightComboPage />,
  },
  {
    path: '/tokyo-night-combo-ja',
    element: <TokyoNightComboJaPage />,
  },
  {
    path: '/overseas-owners',
    element: <OverseasOwnersPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;